import { Input, Modal, Spin } from "antd"
import phoneticFuntions from "../../SentenceManage/controller/phoneticFuntions"
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import dayjs from "dayjs"
import textToVoice from "controllers/textToVoice";
import textToFile from "controllers/textToFile";
import s3Controller from "controllers/s3Controller";

const backend = process.env.REACT_APP_BACKEND;

function FileCreater ({record, dataChangeHandler, curLanguage }) {
  const [file, setFile] = useState(record.translate_voice_filename)
  const [loading, setLoading] = useState(false)
  // const fileRef = useRef(record.diacritic)

  const listenSectenceVoice = async () => {

    if (record.translate_text === null || record.translate_text === "") {
      Modal.error({
        title: "에러",
        okText: "확인",
        content: "음성 듣기를 실행할 영어단어가 없습니다.",
      });
    } else {
      const text = record.translate_text;
      const speedNum = 1.0;
      const name = `<voice name="${curLanguage.voice_file_speaker}">`;
      const speed = `<prosody rate="${speedNum}">`;

      textToVoice(text, name, speed, (err, result) => {
        Modal.error({
          title: "음성파일 듣기 에러",
          okText: "확인",
          content:
            "Azure SDK에서 에러가 발생하여 정상적으로 듣기를 실행하지 못했습니다.",
        });
      });
    }
  };

  const listenFileVoice = async () => {
    const bucket = "https://englemining-admin.s3.ap-northeast-2.amazonaws.com/";
    const prefix = `word_translate`;
    const audioUrl = bucket + prefix + "/" + file;

    const audio = new Audio(audioUrl);
    audio.play()
    .catch(err=>{
      console.dir(err)
      Modal.error({
        title: "재생에러",
        content: err.message,
        oktext:"확인"
      })
    })
  };

  const createVoiceFile = async () => {
    if (record.translate_text === null || record.translate_text === "") {
      Modal.error({
        title: "에러",
        okText: "확인",
        content: "음성파일을 생성할 영어문장이 없습니다.",
      });
    } else {
      const originRecord = JSON.parse(JSON.stringify(record));
      const instance = {...record};

      const speedNum = 1.0;
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");

      const fileName = `word_translate_${record.id}_${curLanguage.locale}_${currentVer}.mp3`;
      const text = record.translate_text;
      const name = `<voice name="${curLanguage.voice_file_speaker}">`;
      const speed = `<prosody rate="${speedNum}">`;

      textToFile(
        text,
        name,
        speed,
        fileName,
        `word_translate`,
        (err, data) => {
          if (err) {
            Modal.error({
              title: "업로드 에러",
              okText: "확인",
              content:
                "업로드 중 에러가 발생하였습니다. 재시도 하시고 에러가 계속될 경우 관리자에게 문의하세요.",
            });
          } else {
            const newKey = data.Key;
            const prefix = data.Key.split("_").slice(0, -1).join("_");

            const newFileName =
              data.key.split("/")[data.key.split("/").length - 1];

            instance.translate_voice_filename = newFileName;
            setFile(fileName)
            const values = {
              id: record.detail_id, 
              WordExMaster_id: record.id,
              SystemSettingLanguage_code: record.SystemSettingLanguage_code || curLanguage.value,
              translate_voice_filename: fileName
            }

            axios
              .patch(
                `${backend}/contents/new_word/constituent_false/detail`,{values})
              .then((data) => {
                instance.detail_id = data.data.data // id를 넣어주어야 중복값이 생기지 않는다.
                dataChangeHandler(instance, "translate_voice_filename");
                // 기존에 등록된 파일 중 동일id에 해당하는 파일을 지워주는 로직
                s3Controller.s3List(prefix, (err, result) => {
                  if (err) {
                    console.log(err);
                  } else {
                    const files = result.Contents.reduce((acc, cur) => {
                      if (cur.Key === newKey) {
                        return acc;
                      } else {
                        acc.push({ Key: cur.Key });
                        return acc;
                      }
                    }, []);
                    if (files.length !== 0) {
                      s3Controller.s3DeleteFiles(files, (err, data) => {
                        if (err) console.log(err);
                      });
                    }
                  }
                });
                // console.log("d");
              })
              .catch((err) => {
                console.log(err);
                s3Controller.s3DeleteFile(newKey, (err, data) => {
                  if (err) console.log(err);
                });
                Modal.error({
                  afterClose: () => {
                    setFile(originRecord.translate_voice_filename)
                    dataChangeHandler(originRecord, "translate_voice_filename");
                  },
                  title: "서버에러",
                  okText: "확인",
                  content:
                    "서버에 에러가 발생하여 파일을 생성하지 못했습니다. 다시 시도하여 주시고 에러가 지속된다면 관리자에게 문의해주세요.",
                });
              });
          }
        }
      );
    }
  };

  useEffect(()=>{
    setFile(record.translate_voice_filename)
  },[record])

  return (
      <div>
        <a style={{margin:"0px 5px"}} onClick={listenSectenceVoice}>듣기</a>
        <a style={{margin:"0px 5px"}} onClick={createVoiceFile}>생성</a>
        <span>{file}</span>
        {file ? <a style={{margin:"0px 5px"}} onClick={listenFileVoice}>듣기</a> : null}
      </div>
  )
}

export default FileCreater